import React, { Suspense } from 'react'
import { theme } from '../react/layout/Theme'
import { MantineProvider } from '@mantine/core'
import { RouterProvider } from 'react-router/dom'
import { Provider } from 'react-redux'
import LoadingPageLoader from './components/LoadingPageLoader'
import { Notifications } from '@mantine/notifications'

export default function App ({ store, router }) {
  return (
    <React.StrictMode>
      <MantineProvider withCSSVariables withNormalizeCSS theme={theme}>
        <Suspense fallback={<LoadingPageLoader />}>
            <Notifications limit={5} position='top-center'/>
            <Provider store={store}>
              <RouterProvider router={router} />
            </Provider>
        </Suspense>
      </MantineProvider>
    </React.StrictMode>
  )
}
